import React from "react";
import { useNavigate } from "react-router-dom";
import { logout } from "../../types/authService";
import { useUserLogin } from "../../context/AuthContext";
import "../../style/UserProfileMenu.css";

const UserProfileMenu: React.FC = () => {
  const navigate = useNavigate();
  const { setUserLogin } = useUserLogin();

  const userName = localStorage.getItem("userName");
  const role = localStorage.getItem("role");

  const handleLogout = async () => {
    try {
      await logout();          // backend logout
    } catch (err) {
      console.error("Logout error", err);
    } finally {
      localStorage.clear();    // clear storage
      setUserLogin(null);      // clear context
      navigate("/login");      // redirect
    }
  };

  return (
    <div className="profile-menu">
      <div className="profile-header">
        <div className="avatar">
          {userName?.charAt(0).toUpperCase()}
        </div>
        <div>
          <div className="name">{userName}</div>
          <div className="role">{role}</div>
        </div>
      </div>
      <ul className="menu-list">
        {role === "ADMIN" && (<li onClick={() => navigate("/register")}>Register User</li>)}
        <li onClick={() => navigate("/my-profile")}>My Profile</li>
        <li onClick={() => navigate("/change-password")}>Change Password</li>
        <li onClick={() => navigate("/user-settings")}>Settings</li>
        <li className="logout" onClick={handleLogout}>
          Logout
        </li>
      </ul>
    </div>
  );
};

export default UserProfileMenu;
